module.exports = __webpack_public_path__ + "static/img/zejiangwenyi.d395037.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ggw_img/zejiangwenyi.png
// module id = nF4x
// module chunks = 36